import dayjs from 'dayjs';
import {SelectedDateType} from '../shared/types';

export const formatCardNumber = (value: string) => {
  // remove all non-digits
  const digits = value.replace(/\D/g, '');
  // add space after every 4 digits
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ');
};

export const rangeRegex = /^\d{4}\/\d{2}\/\d{2}\s*-\s*\d{4}\/\d{2}\/\d{2}$/;

export const isEmpty = (
  value: unknown
): value is
  | undefined
  | null
  | number
  | string
  | unknown[]
  | Record<PropertyKey, never> => {
  return (
    value === undefined ||
    value === null ||
    Number.isNaN(value) ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  );
};

export const convertToSelectedDate = (
  dateString: string,
  dateFormat: string
): SelectedDateType => {
  const parsed = dayjs(dateString, dateFormat, true);
  return parsed.isValid() ? parsed : null;
};

export const convertToUTCDate = (
  dateString: string,
  isDateTime = true
): string => {
  const parsed = dayjs(dateString);
  return parsed.isValid()
    ? parsed.format(isDateTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD')
    : '';
};

export const convertToISO = (dateString: string) => {
  if (dateString) {
    const [year, month, day] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toISOString();
  } else {
    return null;
  }
};

export const formatYear = (dateStr: string) =>
  new Date(dateStr).getFullYear().toString();

export const formatMonth = (dateStr: string) => {
  const dt = new Date(dateStr);
  return [
    dt.toLocaleString('en-US', {month: 'short'}),
    dt.getFullYear().toString(),
  ];
};
export const formatMonthFull = (dateStr: string) => {
  const dt = new Date(dateStr);
  return `${dt.toLocaleString('en-US', {month: 'long'})} ${dt.getFullYear()}`;
};

export const formatDay = (dateStr: string) =>
  new Date(dateStr).getDate().toString();

export const convertToUTC = (dateString: string): string => {
  const parsed = dayjs.utc(dateString);
  return parsed.isValid() ? `${parsed.format('YYYY/MM/DD HH:mm:ss')} UTC` : '';
};

// format UTC date to long date like "Monday, March 9, 2026" or "March 9, 2026"
export const formatUtcToLongDate = (
  dateString: string,
  showWeekDay = false
): string => {
  const parsedDate = new Date(dateString);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('en-US', {
    ...(showWeekDay ? {weekday: 'long' as const} : {}),
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(parsedDate);
};
